import { Breadcrumbs as MuiBreadcrumbs } from '@mui/material';

import BaseLink from '../BaseLink';
import Text from '../Text';

export interface BreadcrumbItem {
  title: string;
  href?: string;
}

interface Props {
  homeHref: string;
  items: BreadcrumbItem[];
}

export default function Breadcrumbs({ homeHref, items }: Props) {
  return (
    <MuiBreadcrumbs
      aria-label="breadcrumb"
      sx={{ fontSize: '0.875rem' }}
    >
      <BaseLink
        href={homeHref}
        color="inherit"
      >
        Home
      </BaseLink>
      {items.map((item, index) =>
        item.href ? (
          <BaseLink
            href={item.href}
            key={index}
            color="inherit"
          >
            {item.title}
          </BaseLink>
        ) : (
          <Text
            key={index}
            size="small"
            weight="regular"
          >
            {item.title}
          </Text>
        ),
      )}
    </MuiBreadcrumbs>
  );
}
